import React from 'react';
import { Link } from 'react-router-dom';
import { companyInfo } from '../../data/mock';
import SEO from '../seo/SEO';

const PolitiqueConfidentialitePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Politique de Confidentialité | NGL SERVICES"
        description="Politique de confidentialité de NGL SERVICES (vitrier Villiers-sur-Marne 94) : données collectées, finalités, durée de conservation, cookies et vos droits RGPD."
        canonical="/politique-confidentialite"
      />
      <section className="py-16">
        <div className="container mx-auto px-4 max-w-3xl">
          <h1 className="text-3xl md:text-4xl font-bold text-[hsl(215,25%,15%)] mb-2">Politique de confidentialité</h1>
          <p className="text-muted-foreground mb-8">
            NGL SERVICES accorde une grande importance à la protection de vos données personnelles.
            Cette politique explique quelles données nous collectons, pourquoi, et comment exercer vos droits.
          </p>

          <div className="space-y-8 text-slate-700 leading-relaxed">
            <div>
              <h2 className="text-xl font-semibold text-[hsl(215,25%,15%)] mb-2">1. Responsable du traitement</h2>
              <p>
                Le responsable du traitement des données est <strong>{companyInfo.name}</strong>,
                27 avenue André Rouy, 94350 Villiers-sur-Marne — email {companyInfo.email || 'comptaglotech@gmail.com'},
                téléphone {companyInfo.phone}.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-semibold text-[hsl(215,25%,15%)] mb-2">2. Données collectées</h2>
              <p>Dans le cadre de nos prestations et via le formulaire de contact, nous pouvons collecter :</p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>Identité : nom, prénom ;</li>
                <li>Coordonnées : adresse postale, email, téléphone ;</li>
                <li>Informations relatives à votre demande d'intervention (adresse du chantier, description, photos éventuelles) ;</li>
                <li>Données de facturation pour les clients et agences.</li>
              </ul>
            </div>

            <div>
              <h2 className="text-xl font-semibold text-[hsl(215,25%,15%)] mb-2">3. Finalités et base légale</h2>
              <p>
                Vos données sont utilisées pour répondre à vos demandes de devis, réaliser les interventions,
                établir les devis et factures, assurer le suivi client et respecter nos obligations légales et comptables.
                La base légale est l'exécution de mesures précontractuelles/contractuelles, notre intérêt légitime et,
                le cas échéant, votre consentement.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-semibold text-[hsl(215,25%,15%)] mb-2">4. Durée de conservation</h2>
              <p>
                Les données de prospection sont conservées jusqu'à 3 ans après le dernier contact. Les documents
                contractuels et comptables (devis, factures) sont conservés pendant la durée légale applicable
                (jusqu'à 10 ans pour les pièces comptables).
              </p>
            </div>

            <div>
              <h2 className="text-xl font-semibold text-[hsl(215,25%,15%)] mb-2">5. Destinataires</h2>
              <p>
                Vos données sont destinées exclusivement à NGL SERVICES et, le cas échéant, à ses prestataires techniques
                (hébergement, paiement en ligne sécurisé). Elles ne sont jamais vendues à des tiers.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-semibold text-[hsl(215,25%,15%)] mb-2">6. Cookies</h2>
              <p>
                Le site peut utiliser des cookies techniques nécessaires à son bon fonctionnement ainsi que, avec votre
                accord, des cookies de mesure d'audience. Vous pouvez configurer votre navigateur pour refuser les cookies.
              </p>
            </div>

            <div>
              <h2 className="text-xl font-semibold text-[hsl(215,25%,15%)] mb-2">7. Vos droits</h2>
              <p>
                Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés,
                vous disposez d'un droit d'accès, de rectification, d'effacement, de limitation, d'opposition et de
                portabilité de vos données. Pour exercer ces droits, contactez-nous par email à {companyInfo.email || 'comptaglotech@gmail.com'}.
                Vous pouvez également introduire une réclamation auprès de la CNIL.
              </p>
            </div>
          </div>

          <div className="mt-10 flex gap-4">
            <Link to="/mentions-legales" className="text-[hsl(207,78%,42%)] hover:underline">Mentions légales</Link>
            <Link to="/contact" className="text-[hsl(207,78%,42%)] hover:underline">Nous contacter</Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PolitiqueConfidentialitePage;
